import React, { useState } from 'react';

const Tooltip = ({ text, children, innerWidth }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  let screenWidth = window.screen.availWidth;
  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  return (
    <div style={{ position: 'relative' }}>
      <span
        role='button'
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={handleMouseEnter}
        style={{ display: 'inline-block' }}
      >
        {children}
      </span>
      {showTooltip && (
        <div
          style={{
            position: 'absolute',
            left: '80px',
            transform: 'translateX(-50%)',
            backgroundColor: 'white',
            color: 'black',
            padding: '5px',
            borderRadius: '5px',
            zIndex: 1,
            width: '150px'
          }}
        >
          <i className="fa fa-times float-right" style={{ fontSize: screenWidth > 1270 ? '25px' : '14px', }} onClick={handleMouseLeave} aria-hidden="true" />

          {text}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
